import Payment from "assets/menu-icons/Payment";
import projectConfig from "@/projectConfig";

const payment = {
  id: 'payment',
  type: 'group',
  restricted: true,
  visible: projectConfig.payment,
  children: [{
    id: 'payment',
    title: 'Мои счета', 
    type: 'item',
    url: '/payment',
    icon: Payment,
    breadcrumbs: false,
    restricted: true,
    visible: projectConfig.payment,
  }]
}

export default payment;
